const GENERAL_QUESTIONS = [
  {
    title: 'when is the application deadline?',
    content: 'Applications will close on Friday, January 31st at 11:59 PM ET, and all decisions will be released by Saturday, February 1st. We hope to see everyone there, so please make sure to apply!',
  },
  {
    title: 'who can I work with?',
    content: 'You are welcome to work with anyone! Working alone is an option, but we highly recommend working with a team so you can get to know your fellow programmers! Teams can have at most 4 students, no exceptions. If you don’t have a team coming in and would like to make one, we will host a team formation mixer where you’ll be able to find teammates and make new friends!',
  },
  {
    title: "what if I'm new to coding?",
    content: 'We encourage everyone to apply, regardless of their background in tech! Code for good is the perfect opportunity to learn. Even if you have limited coding or technical experience, we will have plenty of beginner-friendly workshops as well as mentors to introduce you to a plethora of tools and technologies and help out if you ever get stuck or run out of ideas.',
  },
  {
    title: 'will there be prizes?',
    content: 'Yes! There will be a grand prize and novice winners for each track. In addition, there will also be many company-sponsored prizes. These often come with the requirement that you incorporate certain technologies into your project. Please check the prizes page and devpost for specifics!',
  },
  {
    title: 'what is the code of conduct?',
    content: 'Participants in Code For Good are expected to adhere to the Duke Community Standard and the MLH Code of Conduct (https://github.com/MLH/mlh-policies/blob/main/code-of-conduct.md). Failure to comply with these rules may result in removal from the event and potential restrictions on participation in future Code for Good and other HackDuke events.'
  },
];

const LOGISTICS_QUESTIONS = [
  {
    title: 'when? where?',
    content: 'Code for Good will kick off Saturday, February 9th at 9:00 AM EST and end Sunday, February 10th 5:00 PM EST. The event will be hosted on Duke University’s West Campus in the Fuqua School of Business. All links and additional info will be included in our hacker guide, which will be sent out before the event begins.',
  },
  {
    title: 'what should I bring?',
    content: 'Bring your laptop, chargers, ethernet cables (or just use Wi-Fi), potential toiletries/sleeping bags, and a spirit to Code for Good!',
  },
  {
    title: 'who can participate?',
    content: 'All students (undergraduate or graduate) 18 years or older can participate. If you are a new grad, we’d love to have you as well! We aim to be beginner-friendly, so all are welcome!',
  },
  {
    title: 'what can I make?',
    content: 'We welcome all software and hardware hacks that align with our tracks. Our mission is to code for social good, so make sure to create a project that is impactful for the track you have chosen! We will also have lab space and limited equipment available for hardware projects.',
  },
];

export { GENERAL_QUESTIONS, LOGISTICS_QUESTIONS };
